import { Show } from "solid-js";
import { GoogleMapsStage } from "./stage/googlemaps";
import { LocaleStage } from "./stage/locale";
import { ThemeStage } from "./stage/theme";
import { ThemePresetStage } from "./stage/themepreset";
import { GoogleCalendarStage } from "./stage/googlecalendar";
import { SoundOptions } from "./stage/soundoptions";
import { SystemOptions } from "./stage/systemoptions";

function Stage(props) {
    return <Show when={props.activeStage === props.stageName}>
        {props.children}
    </Show>

}
export function SetupStage(props) {
    const myTheme = {
        uuid: props.device.theme_uuid
    };
    return <>
        <Stage activeStage={props.stageName} stageName="googlemaps">
            <GoogleMapsStage device={props.device} />
        </Stage>
        <Stage activeStage={props.stageName} stageName="locale">
            <LocaleStage device={props.device} />
        </Stage>
        <Stage activeStage={props.stageName} stageName="themepreset">
            <ThemePresetStage theme={myTheme} />
        </Stage>
        <Stage activeStage={props.stageName} stageName="theme">
            <ThemeStage theme={myTheme} />
        </Stage>
        <Stage activeStage={props.stageName} stageName="soundoptions">
            <SoundOptions device={props.device} />
        </Stage>
        <Stage activeStage={props.stageName} stageName="systemoptions">
            <SystemOptions device={props.device} />
        </Stage>
        <Stage activeStage={props.stageName} stageName="googlecalendar">
            <GoogleCalendarStage device={props.device} />
        </Stage>
    </>
}